// Replace CommentExtension.ts with this simplified version:

import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import type { CommentRange } from './CommentTypes';

export const CommentExtension = Extension.create({
  name: 'comments',

  addStorage() {
    return {
      comments: new Map<string, CommentRange>(),
      activeCommentId: null,
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('comments'),
        props: {
          handleClick: (_view, _pos, event) => {
            const target = event.target as HTMLElement;
            if (target?.classList?.contains('comment-marker')) {
              event.preventDefault();
              event.stopPropagation();
              return true;
            }
            return false;
          },
        },
      }),
    ];
  },

  addCommands() {
    return {
      updateComments:
        (comments: Map<string, CommentRange>) =>
        ({ tr, dispatch }) => {
          if (dispatch) {
            this.storage.comments = comments;
            const newTr = tr.setMeta('comments-update', true);
            dispatch(newTr);
          }
          return true;
        },
    };
  },
});
